function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 600,
  height: 438
}, /*#__PURE__*/React.createElement("rect", {
  width: 600,
  height: 438,
  fill: "#FDF8D4"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.99999C0 0.895423 0.895431 0 2 0H598C599.105 0 600 0.89543 600 2V436C600 437.105 599.105 438 598 438H2C0.895429 438 0 437.105 0 436V1.99999Z",
  fill: "url(#paint0_radial)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M564.5 332C626.08 332 676 282.08 676 220.5C676 158.92 626.08 109 564.5 109C502.92 109 453 158.92 453 220.5C453 282.08 502.92 332 564.5 332ZM564.687 167.991H522.213V202.084H507.454V214.297H522.213V227.116H507.454V239.33H522.213V273.009H564.687C590.23 273.009 609.662 259.255 617.139 239.33H630.622V227.116H620.096C620.354 224.951 620.486 222.74 620.486 220.491V220.191C620.486 218.193 620.382 216.227 620.177 214.297H630.622V202.084H617.391C610.106 181.878 590.522 167.991 564.687 167.991ZM534.087 262.053V239.33H604.129C597.599 252.952 583.569 262.053 564.687 262.053H534.087ZM534.087 227.116H607.767C608.053 225.06 608.198 222.948 608.198 220.791V220.491C608.198 218.382 608.059 216.315 607.786 214.297H534.087V227.116ZM604.219 202.084C597.728 188.27 583.656 178.929 564.687 178.929H534.087V202.084H604.219Z",
  fill: "#FDE09A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3072 338.512C75.7323 354.076 138.951 316.093 154.513 253.683C170.075 191.269 132.092 128.046 69.67 112.486C7.26307 96.9263 -55.9558 134.912 -71.5102 197.33C-87.0792 259.737 -49.0925 322.952 13.3072 338.512ZM61.8614 189.077C74.6426 193.48 83.9899 200.08 82.1533 212.356C80.8242 221.343 75.842 225.694 69.228 227.219C78.31 231.948 82.9317 239.199 78.5291 251.769C73.0655 267.382 60.0854 268.699 42.8238 265.433L38.6345 282.222L28.5116 279.699L32.6461 263.135C30.0224 262.483 27.3411 261.791 24.579 261.042L20.4301 277.683L10.3188 275.161L14.508 258.34C13.5629 258.098 12.6118 257.85 11.654 257.6C10.2158 257.225 8.76248 256.846 7.29145 256.478L-5.88181 253.194L-0.856438 241.606C-0.856438 241.606 6.60236 243.59 6.50146 243.443C9.36734 244.152 10.6388 242.284 11.1405 241.038L17.7603 214.498C18.0086 214.558 18.2519 214.619 18.4865 214.678C18.6032 214.707 18.7179 214.736 18.8299 214.764C18.4263 214.602 18.0601 214.498 17.7776 214.426L22.5002 195.481C22.6242 193.33 21.8832 190.617 17.7833 189.594C17.9419 189.487 10.4312 187.766 10.4312 187.766L13.1241 176.954L27.0845 180.439L27.073 180.491C29.1719 181.013 31.3343 181.509 33.5371 182.011L37.686 165.386L47.803 167.909L43.7377 184.208C46.4537 184.828 49.187 185.453 51.8482 186.116L55.8846 169.924L66.0075 172.447L61.8614 189.077ZM29.8422 249.373C38.102 251.554 56.1544 256.322 59.0244 244.789C61.9653 232.997 44.4576 229.069 35.9145 227.152C34.9599 226.937 34.1172 226.748 33.4275 226.576L27.8687 248.86C28.4351 249.001 29.099 249.176 29.8422 249.373ZM37.631 216.81C44.5176 218.648 59.539 222.657 62.1555 212.175C64.8275 201.453 50.2278 198.221 43.0977 196.643C42.2956 196.465 41.5881 196.308 41.0103 196.164L35.9705 216.375C36.4465 216.494 37.0051 216.643 37.631 216.81Z",
  fill: "#FDE09A"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 464,
  cy: 219,
  r: 68,
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M438.21 186.977H464.114C479.87 186.977 491.813 195.446 496.256 207.769H504.325V215.217H497.956C498.08 216.394 498.144 217.593 498.144 218.812V218.995C498.144 220.366 498.063 221.714 497.906 223.035H504.325V230.483H496.103C491.543 242.635 479.692 251.023 464.114 251.023H438.21V230.483H429.209V223.035H438.21V215.217H429.209V207.769H438.21V186.977ZM445.452 230.483V244.342H464.114C475.63 244.342 484.186 238.791 488.168 230.483H445.452ZM490.387 223.035H445.452V215.217H490.398C490.565 216.447 490.65 217.709 490.65 218.995V219.177C490.65 220.493 490.561 221.781 490.387 223.035ZM464.114 193.647C475.683 193.647 484.264 199.344 488.223 207.769H445.452V193.647H464.114Z",
  fill: "white"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M200.965 235.46C191.881 271.893 154.981 294.065 118.544 284.98C82.122 275.897 59.9495 238.994 69.0369 202.564C78.1159 166.127 115.016 143.952 151.443 153.035C187.877 162.118 210.048 199.025 200.965 235.46Z",
  fill: "#F7931A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.974 209.32C166.328 200.27 159.438 195.406 150.017 192.16L153.073 179.902L145.611 178.043L142.636 189.978C140.674 189.489 138.659 189.028 136.657 188.571L139.654 176.557L132.197 174.698L129.138 186.952C127.515 186.582 125.921 186.216 124.374 185.832L124.382 185.793L114.092 183.224L112.107 191.194C112.107 191.194 117.643 192.462 117.526 192.541C120.548 193.295 121.094 195.295 121.003 196.881L117.522 210.845C117.73 210.899 118 210.975 118.298 211.094C118.049 211.033 117.783 210.964 117.509 210.899L112.63 230.461C112.26 231.379 111.323 232.757 109.21 232.234C109.285 232.342 103.787 230.88 103.787 230.88L100.082 239.421L109.792 241.842C111.599 242.295 113.369 242.769 115.112 243.215L112.024 255.613L119.477 257.473L122.535 245.206C124.571 245.759 126.548 246.269 128.482 246.749L125.434 258.958L132.896 260.818L135.984 248.443C148.707 250.851 158.275 249.88 162.303 238.371C165.548 229.105 162.141 223.76 155.447 220.275C160.322 219.151 163.994 215.944 164.974 209.32ZM147.925 233.226C145.619 242.492 130.018 237.483 124.96 236.227L129.058 219.801C134.116 221.064 150.335 223.563 147.925 233.226ZM150.233 209.186C148.129 217.614 135.144 213.332 130.932 212.282L134.647 197.384C138.859 198.434 152.424 200.394 150.233 209.186Z",
  fill: "white"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M359.225 196.305C359.767 195.905 359.767 195.095 359.225 194.695L348.409 186.716C347.749 186.229 346.816 186.701 346.816 187.521V203.479C346.816 204.299 347.749 204.771 348.409 204.284L359.225 196.305ZM273.316 196C273.316 198.209 271.525 200 269.316 200C267.106 200 265.316 198.209 265.316 196C265.316 193.791 267.106 192 269.316 192C271.525 192 273.316 193.791 273.316 196ZM293.316 196C293.316 198.209 291.525 200 289.316 200C287.106 200 285.316 198.209 285.316 196C285.316 193.791 287.106 192 289.316 192C291.525 192 293.316 193.791 293.316 196ZM309.316 200C311.525 200 313.316 198.209 313.316 196C313.316 193.791 311.525 192 309.316 192C307.106 192 305.316 193.791 305.316 196C305.316 198.209 307.106 200 309.316 200ZM333.316 196C333.316 198.209 331.525 200 329.316 200C327.106 200 325.316 198.209 325.316 196C325.316 193.791 327.106 192 329.316 192C331.525 192 333.316 193.791 333.316 196Z",
  fill: "#231536"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.406 242.305C238.865 241.905 238.865 241.095 239.406 240.695L250.222 232.716C250.882 232.229 251.816 232.701 251.816 233.521V249.479C251.816 250.299 250.882 250.771 250.222 250.284L239.406 242.305ZM325.316 242C325.316 244.209 327.106 246 329.316 246C331.525 246 333.316 244.209 333.316 242C333.316 239.791 331.525 238 329.316 238C327.106 238 325.316 239.791 325.316 242ZM305.316 242C305.316 244.209 307.106 246 309.316 246C311.525 246 313.316 244.209 313.316 242C313.316 239.791 311.525 238 309.316 238C307.106 238 305.316 239.791 305.316 242ZM289.316 246C287.106 246 285.316 244.209 285.316 242C285.316 239.791 287.106 238 289.316 238C291.525 238 293.316 239.791 293.316 242C293.316 244.209 291.525 246 289.316 246ZM265.316 242C265.316 244.209 267.106 246 269.316 246C271.525 246 273.316 244.209 273.316 242C273.316 239.791 271.525 238 269.316 238C267.106 238 265.316 239.791 265.316 242Z",
  fill: "#231536"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 388,
  y: 145,
  width: 152,
  height: 152,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 59,
  y: 145,
  width: 152,
  height: 152.016,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(36.1294) scale(742.862 860.815)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF1D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEFFBC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 464,
  y1: 131.733,
  x2: 464,
  y2: 301.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBCC5F"
})));

var SvgMain = function SvgMain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 438,
    viewBox: "0 0 600 438",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _ref5), _ref6, _ref7, _ref8, _ref9), _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main.3963d212.svg";
export { ForwardRef as ReactComponent };